import { resource, types } from 'constants/accessControl';
import { Can } from 'shared/permission';
import Search from './Search';

const getFieldAccesses = () => ({
  playerId: !!Can({
    type: types.view,
    rule: `${resource.players}.${resource.players}`,
    children: true,
    fallback: false,
  }),
  username: !(
    Can({
      type: types.view,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
    || Can({
      type: types.privateView4,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
  ),
  firstName: !(
    Can({
      type: types.view,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
    || Can({
      type: types.privateView1,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
  ),
  lastName: !(
    Can({
      type: types.view,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
    || Can({
      type: types.privateView1,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
  ),
  documentNumber: !(
    Can({
      type: types.view,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
    || Can({
      type: types.privateView3,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
  ),
  mobileNumber: !(
    Can({
      type: types.view,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
    || Can({
      type: types.privateView2,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
  ),
  email: !(
    Can({
      type: types.view,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
    || Can({
      type: types.privateView2,
      rule: `${resource.players}.${resource.players}`,
      children: false,
      fallback: true,
    })
  ),
  betId: !!Can({
    type: types.view,
    rule: [`${resource.bets}.${resource.casinoBets}`, `${resource.bets}.${resource.sportBets}`, `${resource.players}.${resource.playerCasinoBets}`, `${resource.players}.${resource.playerSportBets}`],
    children: true,
    fallback: false,
  }),
  roundId: !!Can({
    type: types.view,
    rule: [`${resource.bets}.${resource.casinoBets}`, `${resource.bets}.${resource.sportBets}`, `${resource.players}.${resource.playerCasinoBets}`, `${resource.players}.${resource.playerSportBets}`],
    children: true,
    fallback: false,
  }),
  paymentRequestId: !!Can({
    type: types.view,
    rule: [
      `${resource.financials}.${resource.withdrawals}`,
      `${resource.financials}.${resource.deposits}`,
      `${resource.players}.${resource.playerWithdrawals}`,
      `${resource.players}.${resource.playerDeposits}`,
    ],
    children: true,
    fallback: false,
  }),
  playerBonusId: !!Can({
    type: types.view,
    rule: `${resource.bonusManagement}.${resource.bonus}`,
    children: true,
    fallback: false,
  }),
});

const QuickSearch = () => {
  const fieldAccesses = getFieldAccesses();
  const hasFieldAccess = Object.values(fieldAccesses).some(Boolean);

  return hasFieldAccess && <Search fieldAccesses={fieldAccesses} />;
};
export default QuickSearch;
